"use strict";

var App = {
    extend: function () {
        var args = Array.prototype.slice.call(arguments);
        args.unshift(this);
        return Object.assign.apply(null, args);
    }
};

/**
 * Shared object usually called "App".
 *
 * @see https://github.com/AmpersandJS/ampersand-app/blob/master/ampersand-app.js
 *
 * @type {object}
 *
 * @author Simone Sacchi
 * @version 2018/10/31
 */
module.exports = App;
